export default "__VITE_ASSET__$Q0aXnZY__"